<div class="modal-header">
  <h5 class="modal-title mb-0 sd-text-primary">Pull Invoicing</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancelAddUpdateModel()"></button>
</div>

<form [formGroup]="pullDataFormFormModel" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="row g-2">
      <div class="col-md-6">
        <label for="materialTypeId" class="form-label">Material Type</label>
        <ng-select [clearable]="false" [items]="_materialTypeList" bindLabel="text" bindValue="value"
          id="materialTypeIds" name="materialTypeId" formControlName="materialTypeId"
          [ngClass]="{'is-invalid':submitted && f.materialTypeId.errors}">
        </ng-select>
        <div *ngIf="submitted && f.materialTypeId.errors" class="invalid-feedback d-block">
          <div *ngIf="f.materialTypeId.errors.required">Material type is required</div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="invoiceDate" class="form-label">Invoice Date</label>
        <div class="position-relative">
          <input type="date" placeholder="DD/MM/YYYY" formControlName="invoiceDate"  [max]="today"
            [ngClass]="{'is-invalid': submitted && f.invoiceDate.errors}" class="form-control" style="height: 36px;" />
        </div>
        <div *ngIf="submitted && f.invoiceDate.errors" class="invalid-feedback d-block">
          <div *ngIf="f.invoiceDate.errors.required">Please select date</div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center p-3">
        <button type="submit" [disabled]="loadingButton" class="btn custom-header rounded-2 btn-sm btn-sm" #submitBtn>
            <i class="fas fa-spinner fa-spin  font-size-16 align-middle me-2" *ngIf="loadingButton"></i>
            <!-- <i class="fas fa-save" *ngIf="!loadingButton"></i> -->
            Save
        </button>
    <!-- <button type="submit" [disabled]="loadingButton" class="btn sd-custom-btn btn-sm" #submitBtn>
      <i class="fas fa-spinner fa-spin  font-size-16 align-middle me-2" *ngIf="loadingButton"></i>
      <i class="fas fa-save" *ngIf="!loadingButton"></i>
      Submit
    </button>
    <button type="button" class="btn btn-danger btn-sm" (click)="cancelAddUpdateModel()">Close</button> -->
  </div>
</form>